import { render } from "./virtualNumber.vue?vue&type=template&id=94359de2&scoped=true"
import script from "./virtualNumber.vue?vue&type=script&lang=js"
export * from "./virtualNumber.vue?vue&type=script&lang=js"

import "./virtualNumber.vue?vue&type=style&index=0&id=94359de2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94359de2"]])

export default __exports__